import { ICON_TYPES } from '../constants';

export const FitnessTrail = (): JSX.Element => {
  return (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_13190_24613)">
        <path
          d="M21.6667 17.5001C21.6667 19.4304 20.097 21.0001 18.1667 21.0001H7.53896L9.32834 19.2501H18.1676C19.1327 19.2501 19.9176 18.4652 19.9176 17.5001C19.9176 16.535 19.1327 15.7501 18.1676 15.7501H13.7926C11.8623 15.7501 10.2926 14.1804 10.2926 12.2501C10.2926 10.564 11.4913 9.15347 13.0812 8.8236L14.7953 10.5001H13.7926C12.8275 10.5001 12.0426 11.285 12.0426 12.2501C12.0426 13.2152 12.8275 14.0001 13.7926 14.0001H18.1676C20.0978 14.0001 21.6667 15.5699 21.6667 17.5001ZM20.3848 7.4691C22.0911 5.76285 22.0911 2.98735 20.3848 1.28198C19.5588 0.455977 18.4598 0.000976562 17.2917 0.000976562C16.1236 0.000976562 15.0246 0.455977 14.1977 1.28198C12.4923 2.98823 12.4923 5.76373 14.2047 7.4761L17.2917 10.4949L20.3848 7.4691ZM19.1476 2.51923C20.1713 3.54298 20.1713 5.2081 19.1546 6.22485L17.2917 8.0466L15.435 6.23185C14.4121 5.2081 14.4121 3.54298 15.435 2.51923C15.9311 2.0231 16.59 1.7501 17.2917 1.7501C17.9935 1.7501 18.6523 2.02398 19.1476 2.51923ZM8.13484 17.9691C9.84109 16.2628 9.84109 13.4874 8.13484 11.782C7.30884 10.956 6.20984 10.501 5.04171 10.501C3.87359 10.501 2.77459 10.956 1.94771 11.782C0.242338 13.4882 0.242338 16.2637 1.95471 17.9761L5.04171 20.9949L8.13484 17.9691ZM6.89759 13.0192C7.92134 14.043 7.92134 15.7081 6.90459 16.7249L5.04171 18.5466L3.18496 16.7319C2.16209 15.7081 2.16209 14.043 3.18496 13.0192C3.68109 12.5231 4.33996 12.2501 5.04171 12.2501C5.74346 12.2501 6.40234 12.524 6.89759 13.0192Z"
          fill="#43494F"
        />
      </g>
    </svg>
  );
};

FitnessTrail.iconType = ICON_TYPES.FITNESS_TRAIL;
